<template>
  <div class="backdrop">
    <div class="backdrop-top">
      <div class="title-box">
        <img src="../../../assets/images/return.png" @click="$router.go(-1)"><span>添加资产盘点单</span>
      </div>
      <div class="list-wrapper">
        <div class="row-item">
          <label>盘点单名称</label>
          <input type="text" v-model.trim="stocktaking_title" placeholder="请输入盘点单名称" >
        </div>
        <div class="row-item" @click="warehouseClick">
          <label>盘点仓库</label>
          <input type="text" v-model="storage_name" placeholder="请选择盘点仓库" readonly>
          <img src="../../../assets/images/right_jt.png">
        </div>
        <div class="row-item">
          <label style="flex: 1">是否允许手工盘点</label>
          <mt-switch v-model="handwork_allow"></mt-switch>
        </div>
        <div class="row-item" style="margin-top: 8px;color: #8c8c8c;">盘点范围</div>
        <div class="row-item" @click="areaClick">
          <label>区域</label>
          <input type="text" v-model="area_name" placeholder="请选择区域" readonly>
          <img src="../../../assets/images/right_jt.png">
        </div>
        <div class="row-item" @click="userClick">
          <label>使用人</label>
          <input type="text" v-model="keeper_member_name" placeholder="请选择使用人" readonly>
          <img src="../../../assets/images/right_jt.png">
        </div>
        <div class="row-item" @click="classifyClick">
          <label>资产分类</label>
          <input type="text" v-model="category_name" placeholder="请选择资产分类" readonly>
          <img src="../../../assets/images/right_jt.png">
        </div>
        <div class="row-item">
          <label>起始购入时间</label>
          <input type="text" @click="selectData1" v-model="date_time1" placeholder="请选择起始时间" readonly>
          <mt-datetime-picker ref="datePicker1" type="date" v-model="pickerValue1" @confirm="handleConfirm1"></mt-datetime-picker>
          <img src="../../../assets/images/right_jt.png">
        </div>
        <div class="row-item">
          <label>截止购入时间</label>
          <input type="text" @click="selectData2" v-model="date_time2" placeholder="请选择截止时间" readonly>
          <mt-datetime-picker ref="datePicker2" type="date" v-model="pickerValue2" @confirm="handleConfirm2"></mt-datetime-picker>
          <img src="../../../assets/images/right_jt.png">
        </div>
      </div>
    </div>
    <button class="preserve" @click="commit">创建盘点单</button>

    <!-- 选择盘点仓库 -->
    <div class="select-mask" v-if="warehousePopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择盘点仓库<img class="close-mask" @click="warehouseClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="warehouseData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectStorage"></el-tree>
        </div>
      </div>
    </div>

    <!-- 选择区域 -->
    <div class="select-mask" v-if="areaPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择区域<img class="close-mask" @click="areaClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="areaData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectArea"></el-tree>
        </div>
      </div>
    </div>

    <!-- 选择使用人 -->
    <div class="select-mask" v-if="userPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择使用人<img class="close-mask" @click="userClose" src="../../../assets/images/close.png"></div>
          <div class="search-box" style="padding: 15px 0">
            <input type="text" v-model="userKeywords" placeholder="请输入姓名/手机号" @keyup.enter="findUser" @input="findUser">
          </div>
          <el-tree :data="userData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectKeeper"></el-tree>
        </div>
      </div>
    </div>

    <!-- 选择资产分类 -->
    <div class="select-mask" v-if="classifyPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择资产分类<img class="close-mask" @click="classifyClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="classifyData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectCategory"></el-tree>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'AssetStocktakingAdd',
  metaInfo: {
    title: '添加资产盘点单'
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  created () {
    // 解决安卓软键盘弹出布局问题
    let bodyHeight = document.documentElement.clientHeight + 'px'
    window.addEventListener('resize', () => {
      document.body.style.height = bodyHeight
    })

    this.getStorageTree()
    this.getAreaTree()
    this.getUserTree()
    this.getCategoryTree()
  },
  data () {
    return {
      stocktaking_title: '',
      storage_id: 0,
      storage_name: '',
      handwork_allow: false,
      area_id: 0,
      area_name: '',
      keeper_member_id: 0,
      keeper_member_name: '',
      category_id: 0,
      category_name: '',
      date_time1: '',
      date_time2: '',
      pickerValue1: new Date(),
      pickerValue2: new Date(),
      areaPopup: false, // 区域
      areaData: [],
      warehousePopup: false, // 仓库
      warehouseData: [],
      userPopup: false, // 使用人
      userData: [],
      allUserData: [],
      userKeywords: '',
      classifyPopup: false, // 分类
      classifyData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  methods: {
    getStorageTree () {
      this.axios.post('/wechat/basic_info/getStorageTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.warehouseData = res.data.data
        }
      })
    },
    getCategoryTree () {
      this.axios.post('/wechat/basic_info/getCategoryTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.classifyData = [{id: 0, label: '请选择资产分类'}].concat(res.data.data)
        }
      })
    },
    getAreaTree () {
      this.axios.post('/wechat/basic_info/getAreaTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.areaData = [{id: 0, label: '请选择区域'}].concat(res.data.data)
        }
      })
    },
    getUserTree () {
      this.axios.post('/wechat/basic_info/getVillageMemberTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.allUserData = [{id: 0, label: '请选择使用人'}].concat(res.data.data)
          this.userData = [{id: 0, label: '请选择使用人'}].concat(res.data.data)
        }
      })
    },
    findUser () {
      this.userData = []
      var keywords = this.userKeywords
      let that = this
      this.allUserData.forEach(function (detail) {
        if (detail.label.indexOf(keywords) !== -1) {
          that.userData.push(detail)
        }
      })
    },
    commit () {
      if (this.stocktaking_title === '') {
        this.$toast({
          message: '请输入盘点单名称',
          duration: 3000
        })
        return false
      }
      if (this.storage_id === 0) {
        this.$toast({
          message: '请选择仓库',
          duration: 3000
        })
        return false
      }
      this.axios.post('/wechat/stocktaking/addAssetStocktaking', {
        member_id: this.memberId,
        village_id: this.villageId,
        stocktaking_title: this.stocktaking_title,
        storage_id: this.storage_id,
        handwork_allow: this.handwork_allow,
        area_id: this.area_id,
        keeper_member_id: this.keeper_member_id,
        category_id: this.category_id,
        purchase_start_time: this.date_time1,
        purchase_end_time: this.date_time2
      }).then((res) => {
        if (res.data.status === 1) {
          this.$toast({
            message: '创建成功',
            duration: 5000
          })
          this.$router.go(-1)
        } else {
          this.$toast({
            message: res.data.info,
            duration: 5000
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },

    // 打开时间选择器
    selectData1 () {
      this.$refs['datePicker1'].open()
      let a = document.getElementsByClassName('picker-solt')
      console.log(a.length)
      for (let i = 0; i < a.length; i++) {
        console.log(i)
        if (i === 2) {
          a[i].style.display = 'none'
        }
      }
    },
    // 打开时间选择器
    selectData2 () {
      this.$refs['datePicker2'].open()
      let a = document.getElementsByClassName('picker-solt')
      console.log(a.length)
      for (let i = 0; i < a.length; i++) {
        console.log(i)
        if (i === 2) {
          a[i].style.display = 'none'
        }
      }
    },
    // 选择时间点击确定按钮
    handleConfirm1 (val) {
      let date = val
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      let resDate = year + '-' + month + '-' + day
      this.date_time1 = resDate
    },
    // 选择时间点击确定按钮
    handleConfirm2 (val) {
      let date = val
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      let resDate = year + '-' + month + '-' + day
      this.date_time2 = resDate
    },
    // 点击盘点仓库
    warehouseClick () {
      this.warehousePopup = true
    },
    // 关闭盘点仓库弹出
    warehouseClose () {
      this.warehousePopup = false
    },
    // 点击使用人
    userClick () {
      this.userPopup = true
    },
    // 关闭使用人弹出
    userClose () {
      this.userPopup = false
    },
    // 点击分类
    classifyClick () {
      this.classifyPopup = true
    },
    // 关闭分类弹出
    classifyClose () {
      this.classifyPopup = false
    },
    // 点击区域
    areaClick () {
      this.areaPopup = true
    },
    // 关闭区域弹出
    areaClose () {
      this.areaPopup = false
    },
    // 点击空白地方关闭
    clickBlank () {
      this.warehousePopup = false
      this.userPopup = false
      this.classifyPopup = false
      this.areaPopup = false
    },
    selectStorage (data) {
      this.storage_id = data.id
      this.storage_name = data.label
      this.clickBlank()
    },
    selectArea (data) {
      this.area_id = data.id
      this.area_name = data.id === 0 ? '' : data.label
      this.clickBlank()
    },
    selectKeeper (data) {
      this.keeper_member_id = data.id
      this.keeper_member_name = data.id === 0 ? '' : data.label.split('-')[0]
      this.clickBlank()
    },
    selectCategory (data) {
      this.category_id = data.id
      this.category_name = data.id === 0 ? '' : data.label
      this.clickBlank()
    }
  }
}
</script>
<style scoped>
.backdrop {
  background-color: #f6f6f6;
  overflow: hidden;
}
.backdrop-top {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.preserve {
  width: 100%;
  height: 50px;
  border: none;
  font-size: 16px;
  letter-spacing: 2px;
  color: #ffffff;
  background-color: #ff7c12;
}
.list-wrapper .row-item {
  display: flex;
  /* margin: 0 15px; */
  padding: 10px 15px;
  border-bottom: 1px solid #f6f6f6;
  font-size: 15px;
  background-color: #ffffff;
}
.list-wrapper .row-item input {
  flex: 1;
  width: 100%;
  border: none;
  outline: none;
  font-size: 15px;
  text-align: right;
  padding: 0;
}
.list-wrapper .row-item img {
  width: 12px;
  height: 12px;
  vertical-align: top;
  padding: 5px 0 0 5px;
}
.select-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.select-mask .select-mask-blank {
  width: 100%;
  height: 100%;
}
.select-mask .select-mask-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  font-size: 15px;
  height: 300px;
  overflow-y: auto;
}
.select-mask .select-mask-inner .select-mask-content {
  padding: 0 15px;
}
.select-mask .select-mask-inner .head-mask {
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
}
.select-mask .select-mask-inner .head-mask .close-mask {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 10px;
}
.select-mask .select-mask-inner .select-mask-content .level {
  border-bottom: 1px solid #f6f6f6;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  position: relative;
}
.select-mask .select-mask-inner .select-mask-content label {
  display: block;
  border-bottom: 1px solid #f6f6f6;
  padding: 5px 15px;
}
>>>
.mint-switch-core {
  width: 42px;
  height: 22px;
}
>>>
.mint-switch-core::before {
  width: 40px;
  height: 20px;
}
>>>
.mint-switch-core::after {
  width: 20px;
  height: 20px;
}
>>>
.el-tree-node__expand-icon {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/AssetStocktaking/AssetStocktakingAdd.vue